import { render } from "./UserFeedback.vue?vue&type=template&id=9d726fc8&scoped=true"
import script from "./UserFeedback.vue?vue&type=script&lang=js"
export * from "./UserFeedback.vue?vue&type=script&lang=js"

import "./UserFeedback.vue?vue&type=style&index=0&id=9d726fc8&scoped=true&lang=scss"

import exportComponent from "/builds/cloud/messenger/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d726fc8"]])

export default __exports__